/* Preorder request modal.
   Когда включён преордер, кнопка открывает модалку с формой имя+email.
   Заявка уходит через нативную Shopify contact form (письмо на контактный
   email магазина) — БЕЗ добавления в корзину. Сабмит через fetch (без
   перезагрузки); при сбое JS форма отправится обычным POST'ом. */
(() => {
  const lockScroll = (on) => {
    document.documentElement.style.overflow = on ? 'hidden' : '';
  };

  const open = (modal) => {
    if (!modal) return;
    modal.hidden = false;
    modal.style.display = 'flex';
    modal.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    const focusable = modal.querySelector('input, button');
    if (focusable) focusable.focus();
  };

  const close = (modal) => {
    if (!modal) return;
    modal.hidden = true;
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
    lockScroll(false);
  };

  // Открытие
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-js-preorder-open]');
    if (!opener) return;
    e.preventDefault();
    const root = opener.closest('product-page') || document;
    open(root.querySelector('[data-js-preorder-modal]'));
  });

  // Закрытие: оверлей, крестик, Esc
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-js-preorder-close]')) {
      close(e.target.closest('[data-js-preorder-modal]'));
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document
        .querySelectorAll('[data-js-preorder-modal]:not([hidden])')
        .forEach(close);
    }
  });

  // Отправка
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.preorder-form');
    if (!form) return;
    e.preventDefault();

    const modal = form.closest('[data-js-preorder-modal]');
    const status = modal && modal.querySelector('[data-js-preorder-status]');
    const submit = form.querySelector('[type="submit"]');

    // подставить актуально выбранный вариант в тело письма
    try {
      const root = modal && modal.closest('product-page');
      const idInput = root && root.querySelector('.product--add-to-cart-form [name="id"]');
      const bodyField = form.querySelector('[data-js-preorder-body]');
      if (bodyField && idInput && idInput.value) {
        bodyField.value = bodyField.value.replace(/variant\s+\d+/, 'variant ' + idInput.value);
      }
    } catch (_) {}

    const email = form.querySelector('[name="contact[email]"]');
    if (email && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.value)) {
      email.focus();
      return;
    }

    if (submit) submit.disabled = true;
    try {
      const res = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        redirect: 'follow',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      // Shopify при успехе редиректит на ...?contact_posted=true
      if (!/contact_posted=true/.test(res.url)) throw new Error('not-sent');
      form.hidden = true;
      if (status) status.hidden = false;
    } catch (err) {
      if (submit) submit.disabled = false;
      if (status) {
        status.hidden = false;
        status.classList.add('is-error');
        status.textContent = status.dataset.errorText || 'Something went wrong. Please try again.';
      }
    }
  });
})();